import Layout from "../../../../components/layout/Layout";
import { useFrontofficeContext } from "../../../../context/FrontofficeContext";
import { useLanguageContext } from "../../../../context/LanguageContext";
import { StyledAltButton } from "../../../../styles/ButtonStyles";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";

function ButtonPageView({ button, layout }) {
  const { updatePage } = useFrontofficeContext();
  const { translateEntity, translate } = useLanguageContext();

  return (
    <Layout
      layoutData={layout}
      content={
        <StyledFlexColumn>
          <p
            dangerouslySetInnerHTML={{
              __html: translateEntity(button, "message"),
            }}
          />

          <StyledAltButton onClick={() => updatePage("start")}>
            {translate("eva.frontoffice.general.back")}
          </StyledAltButton>
        </StyledFlexColumn>
      }
    />
  );
}

export default ButtonPageView;
